import "./App.css";
import MyNftEmpty from "./Components/MyNftEmpty/MyNftEmpty";
import Header from "./Components/Home/Header/Header";
import Home from "./Components/Home/Home";
import MyNFT from "./Components/MyNFT/MyNFT";
// import { getNftData } from "./Components/MyNFT/MyNftData";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { useState } from "react";

import Web3 from "web3";
import NftTransferModel from "./Model/NftTransferModel";
import Trade from "./Components/Trade/Trade";

function App() {
  const [walletAddress, setWalletAddress] = useState(null);

  const connectWallet = async () => {
    try {
      await window.ethereum.enable();

      const web3 = new Web3(window.ethereum);
      const accounts = await web3.eth.getAccounts();

      if (accounts.length > 0) {
        setWalletAddress(accounts[0]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const renderWalletAddress = () => {
    if (!walletAddress) {
      return null;
    }

    const stringsAdress =
      walletAddress.slice(0, 7) + "....." + walletAddress.slice(-7);
    return <div>{stringsAdress}</div>;
  };
  console.log("walletAddress", walletAddress);
  return (
    <>
      <BrowserRouter>
        <Header
          address={walletAddress}
          connect={connectWallet}
          renderWalletAddress={renderWalletAddress}
        />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <Home
                address={walletAddress}
                connect={connectWallet}
                renderWalletAddress={renderWalletAddress}
              />
            }
          />
          <Route exact path="/Trade" element={<Trade />} />

          <Route
            exact
            path="/myNft"
            element={
              walletAddress ? (
                <MyNFT connect={connectWallet} address={walletAddress} />
              ) : (
                <MyNftEmpty />
              )
            }
          />
        </Routes>
        <NftTransferModel
          address={walletAddress}
          connect={connectWallet}
          renderWalletAddress={renderWalletAddress}
        />
      </BrowserRouter>
    </>
  );
}

export default App;
